import { takeLatest, put, delay, fork, call, all } from "redux-saga/effects"
import { G_LOGIN_START } from "./constant"
import { GloginApi } from "./Gapi"
import { gLoginSuccess, gLoginError } from "./action"

export function* GoogleLoginAsync({ payload: { payload, history } }) {
  try {
    const response = yield call(GloginApi, payload)

    if (response.status === 200) {
      yield delay(500)
      yield put(gLoginSuccess(response.data))
      history("/dashboard")
    } else {
      yield put(gLoginError(response.data))  
      history("/register")
    }
  } catch (error) {
    yield put(gLoginError(error.response.data))
    history("/register")
  }
}

export function* Gloginfunction() {
  yield takeLatest(G_LOGIN_START, GoogleLoginAsync)
}

function* GloginSaga() {
  yield all([fork(Gloginfunction)])
}
export default GloginSaga
